import type { Group, GroupId } from 'types/group'
import type { ZipUrls } from 'types/playlist'
import type { RootGroup } from 'types/shareable-channel'
import * as types from './types'
export const loadGroupContents = (
  group: Group | RootGroup,
): {
  group: Group | RootGroup
  type: string
} => ({
  type: types.LOAD_GROUP_CONTENTS,
  group,
})
export const loadGroupContentsSuccess = (
  group: Group | RootGroup,
  response: any,
): {
  group: Group | RootGroup
  response: any
  type: string
} => ({
  type: types.LOAD_GROUP_CONTENTS_SUCCESS,
  group,
  response,
})
export const loadGroupContentsFail = (
  group: Group | RootGroup,
  error: Error,
): {
  error: Error
  group: Group | RootGroup
  type: string
} => ({
  type: types.LOAD_GROUP_CONTENTS_FAIL,
  group,
  error,
})
export const loadGroupContentsNext = (
  groupId: GroupId,
): {
  groupId: GroupId
  type: string
} => ({
  type: types.LOAD_GROUP_CONTENTS_NEXT,
  groupId,
})
export const loadGroupContentsNextSuccess = (
  groupId: GroupId,
  response: any,
): {
  groupId: GroupId
  response: any
  type: string
} => ({
  type: types.LOAD_GROUP_CONTENTS_NEXT_SUCCESS,
  groupId,
  response,
})
export const loadGroupContentsNextFail = (
  groupId: GroupId,
  error: Error,
): {
  error: Error
  groupId: GroupId
  type: string
} => ({
  type: types.LOAD_GROUP_CONTENTS_NEXT_FAIL,
  groupId,
  error,
})
export const loadRootGroup = (rootGroup: RootGroup) => ({
  type: types.LOAD_ROOT_GROUP,
  rootGroup,
})
export const loadRootGroupZipUrls = (zipUrls: ZipUrls) => ({
  type: types.LOAD_ROOT_GROUP_ZIP_URLS,
  zipUrls,
})
